import { State, Action, StateContext, Selector, Store, Select } from '@ngxs/store';
import { patch } from '@ngxs/store/operators';
import { Injectable } from '@angular/core';
import * as InventoryModels from '../../models/inventory/inventory';
import { BannerService } from '../../shared/services/banner.service';
import { HelperService } from '../../../../src/app/services/helper/helper.service';
import { empty } from 'rxjs';
import { saveAs } from 'file-saver';
import * as DocumentActions from './document.action';
import { DocumentService } from './document.service';

import { SaveState } from '../../models/commonModels';
import * as Models from '../../models/commonModels';


export interface DocumentStateModel {
  }

@State<DocumentStateModel>({
  name: 'documentState',
  defaults: {
  }
})

@Injectable()

  export class DocumentState {

    constructor(
      private documentService: DocumentService,
      private bannerService: BannerService,
      private helperService: HelperService
  ) { }


  @Action(DocumentActions.Download)
  GetManual(
    context: StateContext<DocumentStateModel>,
    action: DocumentActions.Download
  ) {

    this.bannerService.info('Rozpoczęto pobieranie dokumentu.');

    this.documentService.download(action.Id).subscribe(
      res => {

        const file = new File([res.body], this.helperService.GetFileNameFromHttpResponse(res), { type: res.headers.get('Content-Type') });

        saveAs(file);
      },
      res => {
        this.bannerService.error(`Błąd pobierania pliku.`);
      },
      () => {
        this.helperService.consoleLog('DocumentActions.Download');
      }
    );
  }
}

